import React, { useState, useEffect, useMemo, useRef } from 'react';
import Warning from '../warning/warning';
import HowToPlay from '../howToPlay/howToPlay';
import Play from '../play/play';
import GalleryVN from '../galleryVN/galleryVN';
import NovelMenu from '../novelMenu/novelMenu';
import Credits from '../credits/credits';
import plot from '../../services/plot';
import loading from'../../images/loading.gif'
import achievements from'../../services/achievements'
import gallery from'../../services/gallery'
import { musicOnSet, resumeEffectsVN, stopEffectsVN, stopEffects, resumeEffects, stopAmbient, resumeAmbient, stopMusic, resumeMusic } from '../musicEngine/musicEngine';


function App() {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [navigation, setNavigation] = useState( isLS ? localStorage.getItem('navigationSC1') === null ? 0 : parseInt(localStorage.getItem('navigationSC1')) : 0);
  const [disclaimerShown, setDisclaimerShown] = useState(false);
  const [step, setStep] = useState( isLS ? localStorage.getItem('stepSC1') === null? 0 : parseInt(localStorage.getItem('stepSC1')) : 0 );
  const [howToPlayGuide, setHowToPlayGuide] = useState(isLS ? localStorage.getItem('howToPlayGuideSC') === null ? 0 : JSON.parse(localStorage.getItem('howToPlayGuideSC')) : 0);
  const [language, setLanguage] = useState( isLS ? localStorage.getItem('langSC') === null ? "en" : parseInt(localStorage.getItem('langSC')) : "en");
  const [sound, setSound] = useState( isLS ? localStorage.getItem('soundSC') === null ? 1 : parseInt(localStorage.getItem('soundSC')) : 1);

  let state = useRef(isLS ? localStorage.getItem('stateSC1') === null ? new Array() : JSON.parse(localStorage.getItem('stateSC1')) : new Array());
  let achievementsSave = useRef(isLS ? localStorage.getItem('achievementsSave') === null ? achievements : JSON.parse(localStorage.getItem('achievementsSave')) : achievements);
  let gallerySC = useRef(isLS ? localStorage.getItem('gallerySC') === null ? gallery : JSON.parse(localStorage.getItem('gallerySC')) : gallery);
  let phoebesComfort = useRef(isLS ? localStorage.getItem('phoebesComfort') === null ? 1 : JSON.parse(localStorage.getItem('phoebesComfort')) : 1);
  let achievementCondition = useRef(isLS ? localStorage.getItem('achievementCondition') === null ? true : JSON.parse(localStorage.getItem('achievementCondition')) : true);

  let defaultMenu = useRef(false);
  const [hzAdjuster, setHzAdjuster] = useState(false);



  useEffect(() => {
    detectRefreshRate().then((rate) => {
      rate=100/roundFive(rate);
      setHzAdjuster(rate);
    });
    document.addEventListener('deviceready', deviceReadyFunc, false);

  function deviceReadyFunc(){
    document.addEventListener('pause', onPause, false);
    document.addEventListener('resume', onResume, false);
  }

  const onPause = () => {
    stopMusic();
    stopAmbient();
    stopEffects();
    stopEffectsVN();
  };

  const onResume = () => {
    resumeMusic();
    resumeAmbient();
  };
  return () => {
    document.removeEventListener('pause', onPause);
    document.removeEventListener('resume', onResume);
  };
},[]);

useMemo(() => {
  for(let i = 0;i<achievements.length;i++){
    if(achievementsSave.current[i] && achievementsSave.current[i][1] !== achievements[i][1]){
      achievementsSave.current[i][1] = achievements[i][1];
    }else if(!achievementsSave.current[i]){
      achievementsSave.current.splice(i, 1, achievements[i]);
    }
  }
  for(let i = 0;i<gallery.length;i++){
    if(gallerySC.current[i] == undefined && gallery[i]){
      gallerySC.current[i] = gallery[i];
    }
    gallerySC.current[i][0] = gallery[i][0];
  }
  if(isLS){
  localStorage.setItem('achievementsSave', JSON.stringify(achievementsSave.current));
  localStorage.setItem('gallerySC', JSON.stringify(gallerySC.current));
}
  if(step>=plot.length){
    setNavigation(1);
    defaultMenu.current = true;
  }
  if(isLS){
  if(localStorage.getItem('langSC') === null){
    setLanguage("en");
  }else{
    setLanguage(localStorage.getItem('langSC'));
  }
  }else{
  setLanguage("en");
  }
  if(sound !== 1){
    musicOnSet(false);
  }
}, []);

  function goPlay(){
setTimeout(go,300);
    function go(){
    if(isLS){
    localStorage.setItem('navigationSC1', 2);
    }
    setNavigation(2);
  }
  }
  function goMenu(){
    if(isLS){
    localStorage.setItem('navigationSC1', 1);
    }
    setNavigation(1);
  }
  function goToGallery(){
    if(isLS){
    localStorage.setItem('navigationSC1', 4);
    }
    setNavigation(4);
  }
  function goToCredits(){
    if(isLS){
    localStorage.setItem('navigationSC1', 5);
    }
    setNavigation(5);
  }
  function setLang(lang){
    if(isLS){
    localStorage.setItem('langSC', lang);
    }
    setLanguage(lang);
  }
  function detectRefreshRate() {
      return new Promise((resolve) => {
          const frameTimes = [];
          const framesToMeasure = 70;

          function measureFrame(startTime) {
              requestAnimationFrame((endTime) => {
                  frameTimes.push(endTime - startTime);

                  if (frameTimes.length < framesToMeasure) {
                      measureFrame(endTime);
                  } else {
                      // Calculate average frame duration
                      const avgFrameTime = frameTimes.reduce((a, b) => a + b, 0) / frameTimes.length;
                      const refreshRate = Math.round(1000 / avgFrameTime);
                      resolve(refreshRate);
                  }
              });
          }

          measureFrame(performance.now());
      });
  }
  function roundFive(num){
    let n = num % 10;
    if(n>=5){
      if(n>7.5){
        return num - n + 10;
      }else if(n<=7.5){
        return num - n+5;
      }
    }else if(n<5){
      if(n>2.5){
        return num - n + 5;
      }else if(n<=2.5){
        return num - n;
      }
    }
  }

if(!hzAdjuster){
  return <div style={{display:"flex", width:"100vw", height:"100vh", justifyContent:"center", alignItems:"center"}}><img src={loading} style={{ width:"30vw"}}/></div>;
}

if(!disclaimerShown && navigation !== null && navigation !== 0){
  return (
    <Warning  goNext={goMenu} language={language} setLang={setLang} disclaimerShown={disclaimerShown} setDisclaimerShown={setDisclaimerShown} navigation={navigation} />
);
}

  if(navigation !== null && navigation === 1){
    return (
      <NovelMenu goPlay={goPlay} goToGallery={goToGallery} goToCredits={goToCredits} step={step} setStep={setStep} state={state} achievementsSave={achievementsSave} plot={plot} defaultMenu={defaultMenu.current} language={language} setLang={setLang} sound={sound} setSound={setSound} hzAdjuster={hzAdjuster} />
  );
  }

  if(navigation !== null && navigation === 2 && howToPlayGuide == 0){
    return (
      <HowToPlay  setHowToPlayGuide={setHowToPlayGuide} language={language} />
  );
  }


  if(navigation !== null && navigation === 2 && howToPlayGuide !== 0){
    return (
      <Play step={step} state={state} setStep={setStep} goMenu={goMenu} achievementsSave={achievementsSave} gallerySC={gallerySC} phoebesComfort={phoebesComfort} achievementCondition={achievementCondition} language={language} hzAdjuster={hzAdjuster}/>
  );
  }
  if(navigation !== null && navigation === 3){

}
  if(navigation !== null && navigation === 4){
    return (
      <GalleryVN goMenu={goMenu} gallery={gallerySC} language={language} hzAdjuster={hzAdjuster}/>
  );
  }
  if(navigation !== null && navigation === 5){
    return (
    <Credits goMenu={goMenu} language={language} hzAdjuster={hzAdjuster}/>
  );
  }
  if(navigation !== null && navigation === 0){
    return (
      <Warning  goNext={goMenu} language={language} setLang={setLang} disclaimerShown={disclaimerShown} setDisclaimerShown={setDisclaimerShown} navigation={navigation}/>
  );
  }

}

export function IsLSWork(){
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}

export default App;
